import axios from './api';

const dataService = {
  loadConduct: (class_id) =>
    axios.get('/api/conduct', { params: { class_id } }).then((r) => r.data),

  loadAttendance: (class_id) =>
    axios.get('/api/attendance', { params: { class_id } }).then((r) => r.data),

  loadDiscipline: (class_id) =>
    axios.get('/api/discipline', { params: { class_id } }).then((r) => r.data),

  loadExtTest: (class_id) =>
    axios.get('/api/exttest', { params: { class_id } }).then((r) => r.data),

  loadParentCoop: (class_id) =>
    axios.get('/api/parentcoop', { params: { class_id } }).then((r) => r.data),

  loadMarks: (class_id) =>
    axios.get('/api/marks', { params: { class_id } }).then((r) => r.data),

  loadNotifications: (class_id) =>
    axios.get('/api/get_notif', { params: { class_id } }).then((r) => r.data),

  loadAllNotifications: () =>
    axios.get('/api/get_all_notif').then((r) => r.data),
};

export default dataService;
